export default __webpack_public_path__ + "static/media/AnimalMondey01_02.a4c25342.png";